<template lang="pug">
    .page
      section(v-if="cart.length > 0")
        .container
          b-card
            b-container
              h1 CART
              .row.py-2(v-for="item in cart", :key="item.product_id")
                .col-4.col-md-2
                  .thumbnail(:style="{'background-image': `url(${item.thumbnail_url})`}")
                .col-6.col-md-8
                  router-link(:to="{name: `Piece`, params: { pieceId: item.id, pieceTitle: kebabMe(item.title) }}")
                    h4.m-0 {{ item.title }}
                  p.m-0 {{ item.artist }}
                  b-form-spinbutton.quantitySpinner(v-model="item.quantity", size="sm", :min="1", :max="item.stock")
                  //p.m- {{ formatRands(item.price*item.quantity) }}
                .col-12.col-md-2.text-right
                  span.mr-3 {{ formatRands(item.price*item.quantity) }}
                  a(@click='removeFromCart(item.product_id)', variant="light")
                    font-awesome-icon(icon="times")
                  hr
              hr
              content-loader(:height="7", v-if="alert.loading")
              div(v-else="")
                .row.text-center
                  .col-12
                    p(v-if="!hasAddress") PLEASE COMPLETE YOUR PROFILE BEFORE CHECKING OUT
                    p(v-else="") YOUR MAY PROCEED TO CHECKOUT
                .row
                  .col-md-5.text-center
                    b-button.btn-outline(v-if="!hasAddress", :to="{name: 'AccountAddress', query: { sendmeback: 'true' }}") ADD ADDRESS
                    span(v-else="")
                      span.mr-2 ADDRESS
                      font-awesome-icon.text-success(icon="check")
                  .col-md-2.text-center.p-2
                    font-awesome-icon.d-none.d-md-inline-block(icon="chevron-right")
                    font-awesome-icon.d-inline-block.d-md-none(icon="chevron-down")
                  .col-md-5.text-center
                    span.mr-3 {{ `SUBTOTAL ${formatRands(getCartTotal)}` }}
                    b-button#btnCheckout.btn-outline(:to="{name: 'checkout', params: { type: 'sale' }}", :disabled="!(hasAddress)") CHECKOUT
      nothing(v-else="")
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import { userService } from '@/services';
import standardMix from '@/mixins/standardMix';

export default {
  name: 'CheckoutPage',
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      hasAddress: false,
      fields: [
        { key: 'title', label: 'Piece' },
        { key: 'compPrice', label: 'Price' },
        { key: 'compDiscount', label: 'Discount' },
        { key: 'compQuantity', label: 'Quantity' },
        { key: 'compLineTotal', label: 'Total' },
        { key: 'actions', label: '' },
      ],
    };
  },
  computed: {
    ...mapState('cart', ['cart']),
    ...mapGetters('cart', ['getCartTotal']),
  },
  methods: {
    ...mapMutations('cart', ['addToCart', 'removeFromCart']),
  },
  async created() {
    try {
      this.loading();
      // Check that customer has an address set
      const customer = await userService.getProfile(this.profileId);
      if (customer.address_id) {
        this.hasAddress = true;
      }
    } catch (error) {
      this.error('Error finding user');
    }
    this.clear();
  },
};
</script>

<style lang="scss" scoped>
.thumbnail {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100px;
  height: 100px;
}

.quantitySpinner {
  width: 180px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Cart.vue